import * as React from 'react';
import { useContext } from 'react';
import { Grid } from '@material-ui/core';
import { AuthContext } from '../../_auth/AuthContext';
import { IUserState } from '../../_types/user';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { SearchQueryResult } from '../../_types/search';
import Button from '@material-ui/core/Button';

interface Props {
    results: SearchQueryResult | null,
    PageForward: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    PageBackward: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    Export: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        
    },
    table: {
        maxHeight: 440,
    }, 
    paper: {
        [theme.breakpoints.up('md')]: {
            width: 1280
          },
        [theme.breakpoints.down('md')]: {
            width: 768
        },
        overflowX: 'auto'
    }
//     home: { color: "primary" },
//     away: { color: theme.palette.grey[900] }
}));

const QueryResultsPaged: React.FC<Props> = (prop: Props) => {
//const userState: IUserState = useContext(AuthContext);

const classes = useStyles();
/*
selector
field selector (select fields, sorts)
query builder 
results viewer (paging / download)

*/

return (
    <React.Fragment>
        { (prop.results && prop.results.Results && prop.results.Results.Results) && (
            <Grid direction="column">
                <Grid item>
    
                <Paper className={classes.paper}>
                <TableContainer  className={classes.table}>
                    <Table stickyHeader  size="small">
                        <TableHead>
                            <TableRow>
                            {prop.results.Columns.map(c => {
                                return (
                                    <TableCell>{c.friendly_name}</TableCell>
                                )
                            })}
                            </TableRow>
                        </TableHead>
                        
                        <TableBody>
                            {prop.results.Results.Results.map(rrow => {
                                return (
                                    <TableRow>
                                        {rrow.Result.map(rcol => {
                                            return (
                                                <TableCell>{rcol}</TableCell>
                                            )
                                        })}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        </Table>
                    </TableContainer>
                    </Paper>
         
                </Grid>
                <Grid item>
                    <Grid container direction="row">
                        <Grid item>
                            Showing Page {prop.results.Results.Page}({prop.results.Results.Results.length} records) of {prop.results.Results.Total}, Remaining {prop.results.Results.Remaining}
                        </Grid>
                        
                        <Grid item>
                            <Button onClick={prop.PageBackward} color="primary" disabled={prop.results.Results.Page as number < 2} variant="outlined">Back</Button>
                        </Grid>
                        <Grid item>
                            <Button onClick={prop.PageForward} color="primary" disabled={!prop.results.Results.Remaining} variant="outlined">Next</Button>
                        </Grid>
                        <Grid item>
                            <Button onClick={prop.Export} color="primary" variant="outlined">Download</Button>
                        </Grid>
            

                    </Grid>
                </Grid>
            </Grid>
        )
        }

    </React.Fragment>
)
}

export default QueryResultsPaged;